import { post } from './api';
import axios from 'axios';

export const sendCustomEmail = (to, subject, body) => {
  return post('/api/send-email', { to, subject, body })
    .then(response => {
      console.log('Email sent successfully:', response);
      return response;
    })
    .catch(error => {
      console.error('Failed to send email:', error);
      throw error;
    });
};

export const sendCustomEmailJS = async body => {
  return axios
    .post(
      'https://api.emailjs.com/api/v1.0/email/send-form/',
      new URLSearchParams({
        service_id: 'service_eyyf7wt',
        template_id: 'template_xp25qbb',
        user_id: '2LPtLKMfxBjA4y7c9',
        message: body,
      })
    )
    .then(response => {
      console.log('5588 response', response);
      return response;
    })
    .catch(e => {
      console.log('5588 sendEmails error', e);
      throw e;
    });

};
